/** 与 breakpoints.less / 排版约定对齐 */
export const BREAKPOINT_MOBILE_MAX = 768
export const BREAKPOINT_TABLET_MAX = 1024
export const CONTENT_MAX_WIDTH = 1200

export function getViewportWidth() {
  if (typeof window === 'undefined') return CONTENT_MAX_WIDTH
  return (
    window.innerWidth ||
    (document.documentElement && document.documentElement.clientWidth) ||
    0
  )
}

/**
 * 用于 *View.vue 等设备路由：仅在「手机场景」加载 Mobile 版。
 * iPad / Android 平板走 PC。
 */
export function isPhone() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false
  }
  const ua = navigator.userAgent || ''
  if (
    typeof window.screen !== 'undefined' &&
    window.screen != null &&
    window.screen.width > 0 &&
    window.screen.width <= 400
  )
    return true
  if (/iPhone|iPod/i.test(ua)) return true
  if (/iPad/i.test(ua)) return false
  /** iPadOS 13+ 桌面 UA */
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return false
  }
  if (/Android/i.test(ua)) {
    return /Mobile/i.test(ua)
  }
  return false
}
